import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import googleApiRequest from "../../app/api/google/googleApiRequest";

interface GoogleTagManagerIdState {
  googleTagManagerId: string | null,
  isEnabled: boolean,
  loading: boolean,
  error: string | null
}

const initialState: GoogleTagManagerIdState = {
  googleTagManagerId: null,
  isEnabled: false,
  loading: false,
  error: null
};

export const fetchGoogleTagManagerId = createAsyncThunk(
  'google/TagManagerId',
  async (_, { rejectWithValue }) => {
      try {
          const response = await googleApiRequest.getGoogleTagManagerId();
          if (!response || !response.googleTagManagerId) {
            return rejectWithValue('Invalid response from API');
          }
          return response;
          } catch (error: any) {
          return rejectWithValue({ error: error.data });
      }
  }
)

export const GoogleSlice = createSlice({
  name: 'Google',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGoogleTagManagerId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGoogleTagManagerId.fulfilled, (state, action) => {
        state.loading = false;
        state.googleTagManagerId = action.payload.googleTagManagerId;
        state.isEnabled = action.payload.googleTagManagerId !== "false" && !!action.payload;

      })
      .addCase(fetchGoogleTagManagerId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
})

export default GoogleSlice.reducer;